<template>
  <div class="page-symabio" data-model-id="3396:950">
    <div class="background-image-wrapper">
      <div class="background-image">
          <img
            class="freepik-expand"
            alt="Freepik expand"
            src="/img/freepik-green-long-grass.png"
          />
        <div class="background-overlay" /> 
        <div class="background" />
      </div>
    </div>
    <div class='main-container'>
      <header>
        <div class='burger-wrapper' v-show="tmode || mmode">
          <button class="burger-button" @click="toggleMobileMenu">
            <div class='line1' :class="{ 'active': mobileMenuOpen }"></div>
            <div class='line2' :class="{ 'active': mobileMenuOpen }"></div>
          </button>
        </div>
        
        <div class="navbar" v-show="wsmode">
          <router-link to="/" class="navbar-item">
            <span class="nav-text">Accueil</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/about" class="navbar-item">
            <span class="nav-text">Symabio</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/pagemembres" class="navbar-item">
            <span class="nav-text">Membres</span>
            <div class="nav-underline"></div>
          </router-link>
          <router-link to="/reglement" class="navbar-item">
            <span class="nav-text">Réglementations</span>
            <div class="nav-underline"></div>
          </router-link>
        </div>

        <!-- Mobile Menu -->
        <div class="mobile-menu-overlay" v-show="mobileMenuOpen" @click="closeMobileMenu"></div>
        <div class="mobile-menu" :class="{ 'active': mobileMenuOpen }" v-show="tmode || mmode">
          <div class="mobile-menu-header">
            <img src="/img/logo-symabio.png" alt="Logo Symabio" class="mobile-logo" />
          </div>
          <div class="mobile-menu-links">
            <router-link to="/" class="mobile-navbar-item" @click="closeMobileMenu">Accueil</router-link>
            <router-link to="/about" class="mobile-navbar-item" @click="closeMobileMenu">Symabio</router-link>
            <router-link to="/pagemembres" class="mobile-navbar-item" @click="closeMobileMenu">Membres</router-link>
            <router-link to="/reglement" class="mobile-navbar-item" @click="closeMobileMenu">Réglementations</router-link>
          </div>
          <div class="mobile-menu-footer">
            <div class="social-icons">
              <a href="#" class="social-icon"><img src="/img/gg-facebook.svg" alt="Facebook"></a>
              <a href="#" class="social-icon"><img src="/img/formkit-linkedin.svg" alt="LinkedIn"></a>
              <a href="#" class="social-icon"><img src="/img/akar-icons-instagram-fill.svg" alt="Instagram"></a>
            </div>
          </div>
        </div>

        <router-link to="/" class="logo">
          <img
          class="logo-symabio"
          alt="Logo symabio"
          src="/img/logo-symabio.png"
          />
        </router-link>
      </header>
      <div class="content-flex">
        <div class="subtitle">Symabio en question</div>
       
               
      </div>
      <div class="content-flex-qui-somme-nous">
        <QuiSommeNous />
        <Historique />
      </div>
      <div class="divider"/>
      <div class="content-flex-missions">
        <Missions />
        <MissionsCards />
      </div>
      <div class="content-flex-structure">
        <StrutureSymabio />
        <CardStructureSymabio />
      </div>
      
    </div>
  </div>
</template>

<script>
import QuiSommeNous from "./PageSymabio/sections/QuiSommeNous.vue";
import Historique from "./PageSymabio/sections/Historique.vue";
import Missions from "./PageSymabio/sections/Missions.vue";
import MissionsCards from "./PageSymabio/sections/MissionsCards.vue";
import StrutureSymabio from "./PageSymabio/sections/StrutureSymabio.vue";
import CardStructureSymabio from "./PageSymabio/sections/CardStructureSymabio.vue";
import allMembresData from "@/membres.json"; // Import all members data

export default {
  name: "PageSymabio",
  components: {
    QuiSommeNous,
    Historique,
    Missions,
    MissionsCards,
    StrutureSymabio,
    CardStructureSymabio,
  },
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      showSearchResults: false,
      allMembers: allMembresData, // Store all members for searching
      mobileMenuOpen: false, // Track mobile menu state
    };
  },
  props:{
    wsmode:{
      type: Boolean,
      default: false
    },
    tmode:{
      type: Boolean,
      default: false
    },
    mmode:{
      type: Boolean,
      default: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() { 
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleSearchInput() {
      if (this.searchQuery.length > 1) { 
        this.performSearch();
        this.showSearchResults = true;
      } else {
        this.searchResults = [];
        this.showSearchResults = false;
      }
    },
    performSearch() {
      if (!this.searchQuery) {
        this.searchResults = [];
        this.showSearchResults = false;
        return;
      }
      const lowerQuery = this.searchQuery.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.searchResults = this.allMembers.filter(member => {
        const nom = (member['Nom de la société'] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const zone = (member['Zone'] || member['Zone '] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        const produits = (member['Produits Phares'] || '').toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        
        return nom.includes(lowerQuery) || 
               zone.includes(lowerQuery) || 
               produits.includes(lowerQuery);
      });
      this.showSearchResults = this.searchResults.length > 0;
    },
    navigateToMember(numero) {
      if (numero) {
        this.$router.push(`/detailsMembres/${numero}`);
        this.showSearchResults = false; 
        this.searchQuery = ''; 
        this.searchResults = [];
      }
    },
    handleClickOutside(event) {
      const searchbarElement = this.$el.querySelector('.searchbar .input-container');
      if (searchbarElement && !searchbarElement.contains(event.target)) {
         this.showSearchResults = false;
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
      if (this.mobileMenuOpen) {
        document.body.classList.add('no-scroll');
      } else {
        document.body.classList.remove('no-scroll');
      }
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      document.body.classList.remove('no-scroll');
    }
  }
};
</script>

<style>
.page-symabio {
  height: 100vh;
  margin: 0;
  padding: 0;
  position: absolute;
}
.page-symabio header{
  /* background: linear-gradient(to bottom,#e6e3b5,#e6e3b5) ; */
  background: linear-gradient(to right, #c5c69c, #cdc99c, #ceca9c) ;
  /* background: #ceca9c ; */
  position: fixed;
  height: 120px;
  top:0;
  display: flex;
  flex: 1;
  width: 100%;
  z-index: 99;
}
.page-symabio .burger-wrapper {
  z-index: 1000;
  position: absolute;
  right: 2vw;
  top: 56px;
}
.page-symabio .burger-button {
  height: max-content;
  display: flex;
  flex-direction: column;
  align-items: flex-end ;
  justify-content: center;
  gap:6px;
  cursor: pointer;
  background: none;
  border: none;
}
.page-symabio .line1,.page-symabio .line2{
  border-radius: 2px;
  background: #3b723e;
  height: 3.1px;
  transition: width 0.5s ease-in-out, transform 0.5s ease-in-out;
}
.page-symabio .line1{
  width: 40px;
}
.page-symabio .line2{
  width: 30px;
}

/* Burger menu animation when active */
.page-symabio .line1.active {
  transform: rotate(45deg) translate(6px, 6px);
}
.page-symabio .line2.active {
  transform: rotate(-45deg) translate(7px, -7px);
  width: 40px;
}

/* Mobile Menu */
.page-symabio .mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.page-symabio .mobile-menu {
  position: fixed;
  top: 0;
  right: -100%;
  width: 300px;
  height: 100vh;
  background: #fff;
  z-index: 999;
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
}

.page-symabio .mobile-menu.active {
  right: 0;
}

.page-symabio .mobile-menu-header {
  padding: 24px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.page-symabio .mobile-logo {
  height: 60px;
  width: auto;
}

.page-symabio .mobile-menu-links {
  flex: 1;
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.page-symabio .mobile-navbar-item {
  display: block;
  padding: 16px 24px;
  color: #000;
  text-decoration: none;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 18px;
  font-weight: 300;
  border-bottom: 1px solid #f5f5f5;
  transition: background-color 0.2s ease;
}

.page-symabio .mobile-navbar-item:hover {
  background-color: #f8f9fa;
}

.page-symabio .mobile-navbar-item.router-link-active {
  background-color: #3b723e;
  color: white;
}

.page-symabio .mobile-menu-footer {
  padding: 24px;
  border-top: 1px solid #eee;
}

.page-symabio .social-icons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.page-symabio .social-icon {
  display: block;
  width: 32px;
  height: 32px;
}

.page-symabio .social-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* Global no-scroll class */
.no-scroll {
  overflow: hidden;
}
/* header logo navbar  */
.page-symabio .navbar {
  align-items: center;
  display: inline-flex;
  gap: 4vw;
  right: 3vw;
  position: fixed;
  top: 52px;
}

.page-symabio .navbar-item {
  color: rgba(0, 0, 0, 0.85);
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.5px;
  line-height: 24px;
  text-decoration: none;
  white-space: nowrap;
  width: fit-content;
  position: relative;
  padding: 8px 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.page-symabio .nav-text {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}

.page-symabio .nav-underline {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a);
  transform: translateX(-50%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(59, 114, 62, 0.4);
}

/* Normal hover effect */
.page-symabio .navbar-item:hover {
  color: #000000;
  transform: translateY(-1px);
}

.page-symabio .navbar-item:hover .nav-underline {
  width: 100%;
  box-shadow: 0 4px 12px rgba(59, 114, 62, 0.6);
}

.page-symabio .navbar-item:hover .nav-text {
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Active page styling (router-link-active) */
.page-symabio .navbar-item.router-link-active {
  color: #3b723e;
  font-weight: 500;
  transform: translateY(-1px);
}

.page-symabio .navbar-item.router-link-active .nav-text {
  text-shadow: 0 2px 12px rgba(59, 114, 62, 0.2);
  background: linear-gradient(135deg, #3b723e, #4caf50);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-symabio .navbar-item.router-link-active .nav-underline {
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #3b723e, #4caf50, #66bb6a, #4caf50, #3b723e);
  background-size: 200% 100%;
  animation: shimmer 2s ease-in-out infinite;
  box-shadow: 
    0 2px 8px rgba(59, 114, 62, 0.6),
    0 0 20px rgba(76, 175, 80, 0.3);
}

.page-symabio .navbar-item.router-link-active::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(59, 114, 62, 0.05) 0%, transparent 70%);
  border-radius: 8px;
  z-index: 1;
  opacity: 0;
  animation: glow 2s ease-in-out infinite alternate;
}

/* Enhanced hover effect for active page */
.page-symabio .navbar-item.router-link-active:hover {
  transform: translateY(-2px);
}

.page-symabio .navbar-item.router-link-active:hover .nav-text {
  text-shadow: 0 4px 16px rgba(59, 114, 62, 0.3);
}

.page-symabio .navbar-item.router-link-active:hover .nav-underline {
  height: 4px;
  box-shadow: 
    0 4px 16px rgba(59, 114, 62, 0.8),
    0 0 30px rgba(76, 175, 80, 0.5);
}

/* Animations */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes glow {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.page-symabio .logo {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
  left: 7vw;
  padding: 10px;
  position: fixed;
  top: 24px;
}

.page-symabio .logo-symabio {
  align-self: stretch;
  height: 64px;
  object-fit: cover;
  position: relative;
  width: 100%;
}



.page-symabio .main-container{
  padding-top: 32px;
  height: -webkit-fill-available;
  width: 100vw;
  overflow-y: auto;
  scrollbar-width: 0;
  scrollbar-color: rgba(76, 175, 79, 0.01) transparent;
  /* overflow-x: hidden; */
  scrollbar-width: none;
}
/* Chrome, Edge, Safari */
.page-symabio .overlap::-webkit-scrollbar {
  width: 8px;
}

.page-symabio .overlap::-webkit-scrollbar-track {
  background: transparent;
}

.page-symabio .overlap::-webkit-scrollbar-thumb {
  background: #4caf50;
  border-radius: 4px;
}


.page-symabio .background-image-wrapper {
  position: fixed;
  background: #e6e3b5;
  height: 100vh;
  left: 0;
  top: 0;
  width: 100vw;
  z-index: -999;
}

.page-symabio .background-image {
  height: 100%;
}
.page-symabio .freepik-expand {
  opacity: 0.24;
  object-fit: cover;
  position: fixed;
  top: 0;
  width: -webkit-fill-available;
  animation: parallax 3s ease-in;
}

@keyframes parallax {
  0%{
    scale: 1.5;
  }
  100%{
    scale: 1;
  }
}

.page-symabio .background-overlay {
  background: #01010114;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.page-symabio .background {
  mix-blend-mode: multiply;
  background: #e6e3b57d;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
}


.page-symabio .content-flex {
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin: 20vh 8vw 24px 8vw;
}
.page-symabio .subtitle {
  color: #3b723e;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 4vw;
  font-weight: 300;
  letter-spacing: 0;
  line-height: normal;
  white-space: nowrap;
}

.page-symabio .searchbar {
  align-items: center;
  display: flex;
  gap: 12px; 
  width: 36%;
  position: relative; 
}

.page-symabio .input-container {
  width: -webkit-fill-available;
  position: relative; 
}
.page-symabio .input-container input {
  border: none;
  background: #fffde5cc;
  /* border-radius: 16px; */
  width: -webkit-fill-available;
  height: 64px;
  font-size: 20px;
  font-weight: 300;
  color: #3b723e;
  text-indent: 24px;
  outline-color:  #72703b ;
  outline-width: 2px;
  position: relative; /* For positioning the results list */
}

.search-results-list {
 list-style-type: none;
    margin-top: 0px;
    margin-left: -1px;
    padding: 0px;
    /* margin: 0; */
    /* position: absolute; */
    background-color: #e1e6d5cc;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 16px 16px;
    width: calc(100% - -2px);
    max-height: 207px;
    overflow-y: auto;
}

.search-results-list li {
  padding: 10px 24px; 
  cursor: pointer;
  color: #3b723e; 
  border-bottom: 1px solid #eee; 
}

.search-results-list li:last-child {
  border-bottom: none; 
}

.search-results-list li:hover {
  background-color: #e6e3b5; 
}

.page-symabio .input-container input::placeholder{
  color: #3b723e;
  font-weight: 200;
}

.page-symabio .divider{
  height: 16vh;
}
.page-symabio .content-flex-missions,
.page-symabio .content-flex-qui-somme-nous{
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin: 0px 8vw;
}
.page-symabio .content-flex-missions{
  background: #ffffff;
  margin: 0px;
  padding: 64px 8vw;

}
.page-symabio .content-flex-structure{
  background: #3b723e;
  height: max-content;
  display: flex;
  width: -webkit-fill-available;
}
/* Responsive Design Improvements */

/* Tablet Portrait and Small Laptop - 768px to 1023px */
@media (max-width: 1023px) and (min-width: 768px) {
  .page-symabio .subtitle {
    font-size: 36px;
  }
  
  .page-symabio .content-flex {
    margin: 140px 4vw 24px 4vw;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  .page-symabio .searchbar {
    width: 100%;
  }
  
  .page-symabio .content-flex-missions,
  .page-symabio .content-flex-qui-somme-nous {
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin: 0px 4vw;
  }
  
  .page-symabio .content-flex-missions {
    padding: 48px 4vw;
  }
  
  .page-symabio .content-flex-structure {
    flex-direction: column;
    padding: 32px 0;
  }
}

/* Mobile Landscape - 568px to 767px */
@media (max-width: 767px) and (min-width: 568px) {
  .page-symabio header {
    height: 100px;
  }
  
  .page-symabio .logo {
    left: 4vw;
    top: 18px;
  }
  
  .page-symabio .logo-symabio {
    height: 56px;
  }
  
  .page-symabio .burger-wrapper {
    right: 4vw;
    top: 42px;
  }
  
  .page-symabio .content-flex {
    margin: 120px 4vw 24px 4vw;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .page-symabio .subtitle {
    font-size: 28px;
    text-align: center;
  }
  
  .page-symabio .searchbar {
    width: 100%;
  }
  
  .page-symabio .input-container input {
    height: 56px;
    font-size: 18px;
  }
  
  .page-symabio .content-flex-missions,
  .page-symabio .content-flex-qui-somme-nous {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin: 0px 4vw;
  }
  
  .page-symabio .content-flex-missions {
    padding: 40px 4vw;
  }
  
  .page-symabio .divider {
    height: 8vh;
  }
}

/* Mobile Portrait - up to 567px */
@media (max-width: 567px) {
  .page-symabio header {
    height: 90px;
  }
  
  .page-symabio .navbar {
    top: 90px;
    min-width: 160px;
    padding: 12px;
  }
  
  .page-symabio .logo {
    left: 4vw;
    top: 15px;
  }
  
  .page-symabio .logo-symabio {
    height: 48px;
  }
  
  .page-symabio .burger-wrapper {
    right: 4vw;
    top: 35px;
  }
  
  .page-symabio .line1 {
    width: 32px;
  }
  
  .page-symabio .line2 {
    width: 24px;
  }
  
  .page-symabio .content-flex {
    margin: 110px 4vw 20px 4vw;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  
  .page-symabio .subtitle {
    font-size: 24px;
    text-align: center;
    line-height: 1.2;
  }
  
  .page-symabio .searchbar {
    width: 100%;
  }
  
  .page-symabio .input-container input {
    height: 48px;
    font-size: 16px;
    text-indent: 16px;
  }
  
  .page-symabio .search-results-list {
    max-height: 180px;
  }
  
  .page-symabio .search-results-list li {
    padding: 8px 16px;
    font-size: 14px;
  }
  
  .page-symabio .content-flex-missions,
  .page-symabio .content-flex-qui-somme-nous {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 0px 4vw;
  }
  
  .page-symabio .content-flex-missions {
    padding: 32px 4vw;
  }
  
  .page-symabio .content-flex-structure {
    flex-direction: column;
    padding: 24px 0;
  }
  
  .page-symabio .divider {
    height: 6vh;
  }
}

/* Enhanced Mobile Navigation */
@media (max-width: 1023px) {
  .page-symabio .navbar {
    position: fixed;
    top: 120px;
    right: 0;
    background: rgba(198, 196, 156, 0.95);
    backdrop-filter: blur(10px);
    padding: 20px;
    border-radius: 0 0 0 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 200px;
  }
  
  .page-symabio .navbar-item {
    font-size: 18px;
    padding: 12px 16px;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    text-decoration: none;
    color: #3b723e;
    font-weight: 400;
  }
  
  .page-symabio .navbar-item:hover {
    background-color: rgba(59, 114, 62, 0.1);
  }
}

/* Improved Touch Targets for Mobile */
@media (max-width: 767px) {
  .page-symabio .navbar {
    top: 100px;
    min-width: 180px;
    padding: 16px;
  }
  
  .page-symabio .burger-button {
    padding: 8px;
    min-height: 44px;
    min-width: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .page-symabio .navbar-item {
    font-size: 16px;
    padding: 16px 20px;
    min-height: 44px;
    display: flex;
    align-items: center;
  }
}

/* Background Image Optimizations */
@media (max-height: 1200px) {
  .page-symabio .freepik-expand {
    height: -webkit-fill-available;
    animation: parallax 2s ease-in;
  }
}

@media (max-width: 768px) {
  .page-symabio .freepik-expand {
    opacity: 0.15;
    object-position: center top;
  }
  
  .page-symabio .background {
    background: #e6e3b599;
  }
}

/* Text Readability Improvements */
@media (max-width: 567px) {
  .page-symabio .main-container {
    padding-top: 20px;
  }
  
  /* Ensure text remains readable on small screens */
  .page-symabio .subtitle {
    text-shadow: 0 1px 3px rgba(255, 255, 255, 0.8);
    font-weight: 400;
  }
}
</style>